import api from 'services/api/api';

export const deleteHourlyByFilters = async (filters: any) => {
	const response = await api.post('horaHora/deletarPorFiltros', filters);
	return response.data;
};
